import { formatNumber, formatPercent } from '../../utils/formatters';
import type { FunnelResult } from '../../api/client';
import { COLORS } from '../../utils/constants';

interface FunnelChartProps {
  result: FunnelResult;
}

export default function FunnelChart({ result }: FunnelChartProps) {
  const maxVisitors = result.steps.length > 0 ? result.steps[0].visitors : 1;

  return (
    <div className="card">
      <div className="mb-4 flex items-center justify-between">
        <div>
          <h3 className="text-sm font-semibold text-gray-900">{result.name}</h3>
          <p className="text-xs text-gray-500">
            Overall conversion: {formatPercent(result.totalConversion)}
          </p>
        </div>
      </div>

      {/* Horizontal Funnel */}
      <div className="space-y-3">
        {result.steps.map((step, i) => {
          const widthPercent = (step.visitors / maxVisitors) * 100;
          const isLast = i === result.steps.length - 1;

          return (
            <div key={i}>
              <div className="mb-1 flex items-center justify-between">
                <span className="text-sm font-medium text-gray-700">{step.name}</span>
                <div className="flex items-center gap-3">
                  <span className="text-sm font-semibold text-gray-900">
                    {formatNumber(step.visitors)}
                  </span>
                  <span className="text-xs text-gray-500">
                    {formatPercent(step.conversionRate)}
                  </span>
                </div>
              </div>
              <div className="relative h-10 w-full overflow-hidden rounded-lg bg-gray-100">
                <div
                  className="flex h-full items-center rounded-lg transition-all duration-500"
                  style={{
                    width: `${widthPercent}%`,
                    backgroundColor: COLORS.chart[i % COLORS.chart.length],
                  }}
                >
                  {widthPercent > 15 && (
                    <span className="pl-3 text-xs font-medium text-white">
                      {formatPercent(step.conversionRate)}
                    </span>
                  )}
                </div>
              </div>
              {!isLast && step.dropoff > 0 && (
                <div className="mt-1 flex items-center justify-end gap-1">
                  <span className="text-xs text-red-500">
                    -{formatNumber(step.dropoff)} dropped ({formatPercent(step.dropoffRate)})
                  </span>
                </div>
              )}
            </div>
          );
        })}
      </div>

      {result.steps.length === 0 && (
        <p className="py-8 text-center text-sm text-gray-500">
          No funnel data available yet
        </p>
      )}
    </div>
  );
}
